import { render, staticRenderFns } from "./FolderList.vue?vue&type=template&id=392a8606&scoped=true"
import script from "./FolderList.vue?vue&type=script&lang=ts"
export * from "./FolderList.vue?vue&type=script&lang=ts"
import style0 from "./FolderList.vue?vue&type=style&index=0&id=392a8606&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392a8606",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('392a8606')) {
      api.createRecord('392a8606', component.options)
    } else {
      api.reload('392a8606', component.options)
    }
    module.hot.accept("./FolderList.vue?vue&type=template&id=392a8606&scoped=true", function () {
      api.rerender('392a8606', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tasks/FolderList.vue"
export default component.exports